import styled, { css } from 'styled-components';

import { NotificationBadge, type ChildrenType } from '@xing-com/badge';
import { zIndexElevatedLayer4 } from '@xing-com/layout-tokens';
import { SuperEllipse } from '@xing-com/super-ellipse';
import { spaceXS, spaceL, spaceM } from '@xing-com/tokens';

export const SuperEllipseWithTopBadge: React.FC<{ count: number }> = ({
  count,
}) => {
  return (
    <SuperEllipseWrapper>
      <SuperEllipse type="avatar" size="xxsmall" />
      {count ? (
        <StyledNotificationBadge>{count}</StyledNotificationBadge>
      ) : null}
    </SuperEllipseWrapper>
  );
};

const SuperEllipseWrapper = styled.div`
  display: flex;
  flex: 0 0 auto;
  position: relative;
`;

const spaceForCount = (countString: ChildrenType | undefined): string => {
  const count = Number(countString);
  return count > 99 ? spaceL : spaceM;
};

const StyledNotificationBadge = styled(NotificationBadge)`
  position: absolute;
  z-index: ${zIndexElevatedLayer4};
  top: calc(${spaceXS} * -1);
  right: ${({ children }) => css`calc(${spaceForCount(children)} * -1)`};
`;
